<template>
  <div v-loading="loading" class="share-talent-matrix-users">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <add-users-dialog
            title-text="Выбор пользователей"
            @users-selected="addSelectedUsers"
          >
            <el-button
              slot="reference"
              type="primary"
              size="small"
              icon="fas fa-plus"
            >
              Добавить пользователя
            </el-button>
          </add-users-dialog>
        </div>
      </div>
    </div>
    <div class="addition_users-block">
      <el-table :data="users" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column width="90" align="center">
          <template v-slot="scope">
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить пользователя с видимости матрицы?"
              @confirm="deleteUser(scope.row.id)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadUsers"
      ></paginator>
    </div>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddUsersDialog from "@/components/user/AddUsersDialog.vue";

export default {
  name: "share-talent-matrix-users-table",
  components: {
    AddUsersDialog,
    SearchInput,
    Paginator,
  },
  data() {
    return {
      loading: false,
      users: [],
      filters: {},
    }
  },
  mixins: [paginator],
  mounted() {
    this.loadUsers();
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    loadUsers() {
      this.loading = true;
      this.$api.talentMatrix.matrixShareUsersSearch({
        ...this.filters,
        expand: ['user'].join(),
        matrix_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.users = data.users;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteUser(id) {
      this.loading = true;
      this.$api.talentMatrix.matrixShareUsersDelete({
        ids: [id],
        matrix_id: this.$route.params.id,
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Пользователь успешно удален с видимости матрицы'
          });
        })
        .finally(() => {
          this.loadUsers();
        })
    },
    addSelectedUsers(users) {
      this.loading = true;

      let newUsers = [];

      users.forEach(user => {
        if (this.users.find(val => val.id === user.id)) {
          return;
        }
        newUsers.push(user.id);
      })

      if (newUsers) {
        this.$api.talentMatrix.matrixShareUsersCreate({
          user_ids: newUsers,
          matrix_id: this.$route.params.id,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Пользователи успешно добавлены в видимость матрицы'
            });
            this.loadUsers();
          })
          .finally(()=>{
            this.loading = false;
          })
      }
    },
    filtersChanged() {
      this.loadUsers();
    },
  }
}
</script>

<style scoped lang="scss">
  .share-talent-matrix-users {
    .addition_users-block {
      margin: 25px 0;
    }

    .header-actions {
      display: flex;
      justify-content: space-between;
    }
  }
</style>